<template>
    <router-link
        v-if="to"
        :class="classes"
        :to="to"
        :disabled="disabled"
        v-bind="$attrs"
    >
        <slot />
    </router-link>

    <a
        v-else-if="href"
        :class="classes"
        :href="href"
        :disabled="disabled"
        v-bind="$attrs"
    >
        <slot />
    </a>

    <button
        v-else
        :class="classes"
        :type="type"
        :disabled="disabled"
        v-bind="$attrs"
    >
        <slot />
    </button>
</template>



<script>
export default {
    name: 'BaseButton',

    props: {
        block: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: () => {},
        },
        href: {
            type: String,
            default: () => {},
        },
        to: {
            type: [String, Object],
            default: () => {},
        },
        type: {
            type: String,
            default: () => {},
        },
         disabled: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        inheritedProps() {
            return {
                ...this.$props,
                ...this.$attrs,
            };
        },
        classes() {
            return [
                'btn',
                {
                    'btn--block': this.block,
                },
            ].concat(this.modifiers);
        },
        modifiers() {
            const modifiersArray = this.variant && this.variant.split(' ');
            return this.variant ? modifiersArray.map((modifier) => `btn--${modifier}`) : false;
        },
    },
};
</script>
